import { loaderAction, setServicesSettingsAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";

export const GetServicesSettingsThunk = (args) => async (dispatch, getState) => {
    const { user, currentEstablishment, services_settings } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);
        formData.append('establishment', currentEstablishment);

        const response = await api({ data: formData, link: 'get_ser_setting' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            dispatch(setServicesSettingsAction({
                ...services_settings,
                masters: response.data.masters,
                specializations: response.data.specializations,
                services: response.data.services,
                schedules: response.data.schedules
            }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }
};